fragment NotifyMessageFragment on NotifyMessage {
    id
    type
    message
    errors
}
